import { createSelector } from "reselect";
import type { ICommonWorkspaceState, IWorkspace } from "./types";

const selectWorkspaces = ({ workspaces }: ICommonWorkspaceState) => workspaces;
export const selectActiveWorkspaceId = ({ activeWorkspaceId }: ICommonWorkspaceState) => activeWorkspaceId;
export const selectActiveOpportunityListId = ({ activeListId }: ICommonWorkspaceState) => activeListId;

export const selectActiveWorkSpace = createSelector(
    [selectWorkspaces, selectActiveWorkspaceId],
    (workspaces, activeWorkspaceId) => workspaces.find(({ workspaceId }) => workspaceId === activeWorkspaceId),
);

export const selectActiveOpportunityList = createSelector(
    [selectActiveWorkSpace, selectActiveOpportunityListId],
    (activeWorkspace: IWorkspace | undefined, activeListId: any) =>
        activeWorkspace &&
        activeWorkspace.opportunityLists &&
        activeWorkspace.opportunityLists.find(({ opportunityListId }) => opportunityListId === activeListId),
);
